export class SearchResultEnqueteJsEnv {
  llCategoryCode: string;
  lCategoryCode: string;
  mCategoryCode: string;
  sCategoryCode: string;
  searchKeyWord: string;
  userTracking: string;
  userId: string;
  companyId: string;
  departmentId: string;
  categoryType: string;

  isUseful: boolean = false;
  enqueteMessage: string = "";

  constructor(
    llCategoryCode: string,
    lCategoryCode: string,
    mCategoryCode: string,
    sCategoryCode: string,
    searchKeyWord: string,
    userTracking: string,
    userId: string,
    companyId: string,
    departmentId: string,
    categoryType: string,
  ) {
    this.llCategoryCode = llCategoryCode;
    this.lCategoryCode = lCategoryCode;
    this.mCategoryCode = mCategoryCode;
    this.sCategoryCode = sCategoryCode;
    this.searchKeyWord = searchKeyWord;
    this.userTracking = userTracking;
    this.userId = userId;
    this.companyId = companyId;
    this.departmentId = departmentId;
    this.categoryType = categoryType;
  }
}
